module.exports = __webpack_public_path__ + "static/www/img/course_mySql.8a0e242.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/course/course_mySql.jpg
// module id = 381
// module chunks = 1